'use strict';

module.exports = require('ck-core/source/functions/makeLang')({
	TABS: {
		MINECRAFT: {
			NAME: 'Minecraft Settings',
			TITLE: 'Minecraft'
		},
		ROBLOX: {
			NAME: 'Roblox Settings',
			TITLE: 'Roblox'
		}
	},
	COURSES_TABLE_TITLE: 'All Courses',
	BADGES_TITLE: 'Badges',
	DEFAULT_TABLE_HEADINGS: [
		{
			Header: 'Course Name',
			accessor: 'activityName'
		}
	]
});
